// test1539
(1539 && 0);
